/*
----------------------------
Module - news-filters
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';

    fmg.newsFiltersModal = function(){

        function refresh() {
            
            if (fmg.vars.screensize > 1) {

                if (typeof modal_dialog != "undefined") {
                    modal_dialog.close();
                }

            }
            
        }

        function setupToggleFiltersButton() {
            
            $filters_toggle_btn.on("click", function(){

                var $this = $(this);
                var form_id = '#' + $this.parent().find('form').prop('id');
                
                $.magnificPopup.open({
    
                    showCloseBtn: false,
                    alignTop: true,
    
                    items: {
                        src: form_id,
                        type: 'inline'
                    }
    
                });

                // Store current instance of popup into variable
                modal_dialog = $.magnificPopup.instance;
    
            })

        }

        function setupFiltersDoneButton() {
            
            $filters_done_btn.on("click", function(){

                if (typeof modal_dialog != "undefined") {
                    modal_dialog.close();
                }

            });

        }

        function init() {

            $filters_toggle_btn = $(".news-filters__toggle-btn");
            $filters_done_btn = $(".news-filters-form__done-btn");
            
            if ($filters_toggle_btn.length) {
                setupToggleFiltersButton();
            }

            if ($filters_done_btn.length) {
                setupFiltersDoneButton();
            }
            
        }

        var $filters_toggle_btn;
        var $filters_done_btn;
        var modal_dialog;
        
        return {
            init: init,
            refresh: refresh
        };

    }()

    document.addEventListener("DOMContentLoaded", function () {
        fmg.newsFiltersModal.init();
    });

}());

(function(){
    'use strict';

    fmg.newsFiltering = function(){

        var generateResults = fmg.fn.debounce(function () {

            // Prepare to make a call to funnelback for new results
            // We are adding each field's query string and joining them up later with &
            var new_requested_query_string_array = [];

            // Get selected categories in the form of a query string
            if ($news_category_filter.length) {

                var selected_categories_query_string = $news_category_filter.serialize();

                if (selected_categories_query_string.length) {
                    new_requested_query_string_array.push(selected_categories_query_string);
                }

            }

            // Make a copy of the basic search url endpoint
            var new_requested_search_endpoint = base_search_endpoint;

            var new_requested_query_string = new_requested_query_string_array.join("&");
            
            if (new_requested_query_string.length) {

                // Convert array into a string, joined by &, concatenate with source URL
                new_requested_search_endpoint = new_requested_search_endpoint + "&" + new_requested_query_string;
                
            }

            // Only ajax results if the next requested search is not the same as the previous one
            if (last_requested_search_endpoint !== new_requested_search_endpoint) {

                // When results are returned, we want to take specfic parts and replace the following
                // - Selected filters info
                // - Results summary count
                // - First part results (Featured articles + 2 main results)
                // - Leftover Main results 
                // - Pagination

                $.get( new_requested_search_endpoint, function( data ) {

                    // Selected filters info
                    var $new_selected_categories = $(data).find(news_selected_categories_wrapper_class);

                    if ($new_selected_categories.length) {
                        $news_selected_categories_wrapper.html($new_selected_categories.html());
                    }

                    // Results summary
                    var $new_results_summary = $(data).find(news_results_summary_wrapper_class);

                    if ($new_results_summary.length) {
                        $news_results_summary_wrapper.html($new_results_summary.html());
                    }

                    // First part results
                    var $new_first_part_results = $(data).find(news_first_part_results_wrapper_class);

                    if ($new_first_part_results.length) {
                        $news_first_part_results_wrapper.html($new_first_part_results.html());
                    }
                    
                    // Leftover main results
                    var $new_results_listing = $(data).find(news_results_listing_wrapper_class);

                    if ($new_results_listing.length) {
                        $news_results_listing_wrapper.html($new_results_listing.html());
                    }

                    // Pagination
                    var $new_pagination = $(data).find(news_pagination_wrapper_class);

                    if ($new_pagination.length) {
                        $news_pagination_wrapper.html($new_pagination.html());
                    }

                     // Update URL without reload so that users can press back to last filtered view
                     // First store just the pure URL without query string
                     var history_url = window.location.href.split('?')[0];

                     if (new_requested_query_string.length) {
                        history_url += "?" + new_requested_query_string;
                     }

                     window.history.replaceState("", "", history_url);
                    
                });

                // Remember the last request
                last_requested_search_endpoint = new_requested_search_endpoint;

            }

        }, 700);

        function setupNewsCategoryFilter() {

            $news_category_filter = $("[name='f.Category|newsCategoryPrimary']");

            // Enable the checkboxes which are disabled by default so that users can't click on it until its initialised
            $news_category_filter.prop("disabled", false);

            $news_category_filter.on("change", function() {

                generateResults();

            });

        }

        function setupNewsResetFiltersBtn() {

            $news_reset_filters_btn = $(".news-filters-form__reset-btn");
            
            $news_reset_filters_btn.on("click", function() {

                // Only if there are checked filters, reset the news filter
                if ($news_category_filter.filter(":checked").length) {
                    resetNewsFilters();
                }

            });

        }

        function resetNewsFilters() {

            $news_category_filter.prop('checked', false);
            
            generateResults();

        }

        function init() {

            $news_results_wrapper = $(".news-results");
            $news_filters_form = $("#news-filters-form");

            if ($news_results_wrapper.length && $news_filters_form.length) {

                base_search_endpoint = $news_results_wrapper.data("search-endpoint");

                $news_selected_categories_wrapper = $(news_selected_categories_wrapper_class);
                $news_results_summary_wrapper = $(news_results_summary_wrapper_class);
                $news_first_part_results_wrapper = $(news_first_part_results_wrapper_class);
                $news_results_listing_wrapper = $(news_results_listing_wrapper_class);
                $news_pagination_wrapper = $(news_pagination_wrapper_class);

                if (base_search_endpoint.length) {

                    // Only if .news-results__inner exists and theres a data-search-url then these filters can activate
                    setupNewsCategoryFilter();
                    setupNewsResetFiltersBtn();

                }
                
            }
            
        }

        var $news_results_wrapper;
        var base_search_endpoint;
        var last_requested_search_endpoint;

        var $news_filters_form;
        var $news_category_filter;
        var $news_reset_filters_btn;

        var $news_selected_categories_wrapper;
        var news_selected_categories_wrapper_class = ".news-results__selected-categories";
        var $news_results_summary_wrapper;
        var news_results_summary_wrapper_class = ".news-results__summary";
        var $news_first_part_results_wrapper;
        var news_first_part_results_wrapper_class = ".news-results__listing-first-part";
        var $news_results_listing_wrapper;
        var news_results_listing_wrapper_class = ".news-results__listing-wrapper";
        var $news_pagination_wrapper;
        var news_pagination_wrapper_class = ".news-results__pagination-wrapper";
        
        return {
            init: init
        };

    }()

    document.addEventListener("DOMContentLoaded", function () {
        fmg.newsFiltering.init();
    });

}());
